import { Navigate, useParams } from 'react-router-dom';

import { getChangeV2DashboardPath } from '../helpers';
import { CHANGE_STATUS, LIFECYCLE_STEP } from '../models';
import { useChangeV2Store } from '../state/ChangeV2Store';

// `/change-v2/:changeId` redirects to the furthest stage the change has reached:
// completion, execution, plan, assessment or request.
const WorkspaceRedirect = () => {
  const { changeId } = useParams();
  const { getChange } = useChangeV2Store();
  const change = changeId ? getChange(changeId) : undefined;

  if (!change) return <Navigate to={getChangeV2DashboardPath()} replace />;

  const target =
    change.completion || change.lifecycleStep === LIFECYCLE_STEP.COMPLETION || change.status === CHANGE_STATUS.CLOSED
      ? 'completion'
      : change.plan?.baseline
        ? 'execution'
        : change.assessment?.baseline || change.plan
          ? 'plan'
          : change.assessment
            ? 'assessment'
            : 'request';

  return <Navigate to={target} replace />;
};

export default WorkspaceRedirect;
